import { useEffect, useState } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Input, Table } from 'reactstrap';
import RodinaSelection from './RodinaSelection';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import HandleFoto from './HandleFoto';
import ReactFileReader, { ReactFileReaderProps } from 'react-file-reader';
import DisplayDokument from '../comp/DisplayDokument';
import URLEndPointBE from './URLEndPointBE';
import EscapeTxt from './EscapeTxt';
import DeEscapeTxt from './DeEscapeTxt';
//ts
import IDokument from '../ts/IDokument';
import HandleDokument from './HandleDokument';

function ModifFormDoplnek(props: any) { //props.doplnek
    const { keycloak, initialized } = useKeycloak();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    const klasifikace = useSelector((state: any) => state.miscDicts.klasifikace);
    const pouziti = useSelector((state: any) => state.miscDicts.pouziti);
    //console.log("ModifTable props.edit- T: "+typeof(props.edit)+" / val: "+props.edit)
    
    ////// -BEGIN- DOPLNKY
    const [formId, setFormId] = useState(null); //sent with UpdateDoplnek, BE stamped id on AddDoplnek
    const [formKod, setFormKod] = useState("");
    const [formKlasifikace, setFormKlasifikace] = useState(1);
    const [formNazev, setFormNazev] = useState("");
    const [formPopis, setFormPopis] = useState("");
    const [formNaslapnavrstvaV, setFormNaslapnavrstvaV] = useState(""); //NOT IN USE, AS naslapnavrstva_v
    const [formFormat, setFormFormat] = useState(""); //NOT IN USE
    const [formPodminkaObecna, setFormPodminkaObecna] = useState(""); //NOT IN USE, AS podminka_obecna
    const [formKlad, setFormKlad] = useState(""); //NOT IN USE
    const [formPoznamka, setFormPoznamka] = useState("");
    const [formModifikace, setFormModifikace] = useState("");
    const [formDostupnost, setFormDostupnost] = useState("");
    const [formCenovaHladina, setFormCenovaHladina] = useState(""); //NOT IN USE
    const [formViditelnost, setFormViditelnost] = useState(99);
    const [formPouziti, setFormPouziti] = useState(""); //NOT IN USE
    const [formStromy, setFormStromy] = useState(""); //NOT IN USE
    //// DOPLNKY_POUZITI 6x
    const [formDoplnkyPouziti, setFormDoplnkyPouziti] = useState([{rodina_kod: null, pouziti_id: 99, podminka: ""}]);
    let handleFormDoplnkyPouzitiChanged = (rod: any, pouz: any) => {
        //console.log("handleFormDoplnkyPouzitiChanged("+rod+"/"+pouz+")")
        let formPouziti_sliced = formDoplnkyPouziti.slice();
        let _formPouziti = formPouziti_sliced.map((x: any) => (x.rodina_kod==rod?{...x, pouziti_id: pouz}:x));
        setFormDoplnkyPouziti(_formPouziti);
    }
    //let handleFormPovrchyPouzitiTxtChanged - podm Txt NOT IN USE

    //FOTO NEW !2 now, state: WAITING, INSERT, DELETE
    const [formFotky, setFormFotky] = useState([{id: "", state: "WAITING", type: "", base64: ""}, {id: "", state: "WAITING", type: "", base64: ""}])
    let handlePridatFoto = (i: any, e: any) =>
    {
        let fotky = formFotky.slice();
        //e.base64 size - if larger then popup (file too)
        let file = e.fileList[0]; //name, type
        let handled_fotka = fotky[i];   
            handled_fotka.state = "INSERT";
            handled_fotka.type = file.type;
            handled_fotka.base64 = e.base64;
        setFormFotky(fotky);  
        console.log("formFotky");
        console.log(formFotky);
    }
    let handleSmazatFoto = (i: any) => {
        let fotky = formFotky.slice();
        let handled_fotka = fotky[i];
            handled_fotka.state = "DELETE";
            handled_fotka.base64 = "";
        setFormFotky(fotky);
        console.log("formFotky");
        console.log(formFotky);
    }

    // DOKUMENTY - PDF BLOBs for Doplnek
    const [formDokumenty, setFormDokumenty] = useState<IDokument[]>([]);
    //{dokumentId: 5,    state:"VIEWING",  base64: "" } existing
    //{dokumentId: null, state:"INSERT",   base64: "..." } new -> tb inserted
    //{dokumentId: 7,    state:"DELELE",   base64: "" } delete -> tb deleted
    let handlePridatDokument = (e: any) => {
        let dokumenty = formDokumenty.slice()
        let dokument:IDokument = {dokumentId: null, state:"INSERT", base64d: e.base64}
        dokumenty.push(dokument)
        setFormDokumenty(dokumenty)
    }
    let handleSmazatDokument = (i: number) => {
        let dokumenty=formDokumenty.slice()
        //@ts-ignore  
        dokumenty.at(i).state="DELETE"
        console.log(dokumenty)
        setFormDokumenty(dokumenty)
    }
    //-END-

    //Add new Doplnek funct.
    const AddDoplnek = () => {
        console.log("AddDoplnek() called from ModifFormDoplnek") 
        //        id vv - As NEXTVAL_DOPLNEK stamped on BE
        let _dopl = {  kod: formKod, klasifikace: formKlasifikace, nazev: formNazev, popis: formPopis, naslapnavrstva_v: formNaslapnavrstvaV, format: formFormat, podminka_obecna: formPodminkaObecna, klad: formKlad, poznamka: formPoznamka, modifikace: formModifikace, dostupnost: formDostupnost, cenovahladina: formCenovaHladina, viditelnost: formViditelnost, pouziti: formPouziti, stromy: formStromy } 
         
        //Wrapping obj+pouziti
        let doplnek = { doplnek: _dopl, doplnky_pouziti: formDoplnkyPouziti }
        console.log("doplnek")
        console.log(doplnek)

        let _succ = true;
        let id_doplnek = 0;
        //@ts-ignore                                                                              vv - Possibly null
        axios.post(URLEndPointBE+`/new/doplnek`, doplnek, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
            .then(function(response) {
                console.log("Doplnek - Insert SUCC")
                console.log(response.data);
                id_doplnek=response.data.info;
            })
            .then(() => {
                console.log("then")
                formFotky.forEach(function (foto, i)
                {
                    console.log("foreach")
                    if(foto.state=="INSERT") {
                        console.log("insert")
                        console.log(foto)
                        let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type, image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                        //@ts-ignore                                                                         vv - Possibly null
                        axios.post(URLEndPointBE+`/new/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                            .then(() => {
                                console.log("Foto"+(i+1)+" - Insert SUCC")
                            })
                            .catch(function(error) {
                                console.log(error);
                                _succ = false;
                            })
                    }
                });
            })
            .then(() => {
                console.log("then")
                formDokumenty.forEach(function (dokument)
                {
                    console.log("dokument")
                    switch(dokument.state)
                    {
                        case 'INSERT':
                            //console.log("insert - new dokument")
                            let _dokument = {id: null, prvek_id: formId, prvek_kod: formKod, poradi: null, soubor: null, popis: null, typ: null, dokument: (dokument.base64d).replace("data:application/pdf;base64,",""), stamp: null};
                            axios.post(URLEndPointBE+`/new/dokument`, _dokument, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                            break
                        case 'VIEWING':
                            //console.log("viewing - nothing") 
                            break
                        case 'DELETE':
                            //console.log("deleting - nothing to delete yet")    
                            break  
                        default:
                            //console.log("default - n/a")   
                            break; 
                    }
                });
            })
            .catch(function(error) {
                console.log(error);
                _succ = false;
            })
            console.log("redirecting")
            if(_succ) {
                console.log("navigating, _succ: true")
                setTimeout(function() {
                    navigate('/doplnky', {state: {succ: true, type: 'VLOZENI', item: 'DOPLNKU'}});
                }, 1500);
            }   
    }

    //Update existing Doplnek
    const UpdateDoplnek = () => {
        console.log("UpdateDoplnek() called from ModifFormDoplnek") 

        let updateDopl = { id: formId, kod: formKod, klasifikace: formKlasifikace, nazev: formNazev, popis: formPopis, naslapnavrstva_v: formNaslapnavrstvaV, format: formFormat, podminka_obecna: formPodminkaObecna, klad: formKlad, poznamka: formPoznamka, modifikace: formModifikace, dostupnost: formDostupnost, cenovahladina: formCenovaHladina, viditelnost: formViditelnost, pouziti: formPouziti, stromy: formStromy } 

        let updateDoplnek = { doplnek: updateDopl, doplnky_pouziti: formDoplnkyPouziti }

        console.log("updateDoplnek")
        console.log(updateDoplnek)
        console.log("response - /doplnek/formId")
        let _succ = true;
        //@ts-ignore                                                                                       vv - Possibly null
        axios.put(URLEndPointBE+`/doplnek/`+formId, updateDoplnek, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
            .then(function(response) {
                console.log(response.data);
            }) 
            .then(() => {
                formFotky.forEach(function (foto, i)
                {
                    switch(foto.state) {
                        case 'INSERT':
                            //UPDATE FOTO/id (poradi=i+1)
                            if(foto.id!=="") {
                                let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type , image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                                //@ts-ignore                                                                         vv - Possibly null
                                axios.put(URLEndPointBE+`/update/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - Update SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                 })
                            //INSERT FOTO
                            } else {
                                let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type, image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                                //@ts-ignore                                                                         vv - Possibly null
                                axios.post(URLEndPointBE+`/new/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - Insert SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                })
                            }
                            break;
                        case 'DELETE':
                            //DELETE id
                            if(foto.id!=="") {
                                //@ts-ignore                                                                             vv - Possibly null
                                axios.delete(URLEndPointBE+`/delete/foto/`+foto.id, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - DELETE SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                })
                            }
                            break;
                        default:
                            console.log("default")
                            break;
                    }
                });
            })  
            .then(() => {
                formDokumenty.forEach(function(dokument)
                {
                    switch(dokument.state)
                    {
                        case 'INSERT':
                            //console.log("insert - new dokument")
                            let _dokument = {id: null, prvek_id: formId, prvek_kod: formKod, poradi: null, soubor: null, popis: null, typ: null, dokument: (dokument.base64d).replace("data:application/pdf;base64,",""), stamp: null};
                            axios.post(URLEndPointBE+`/new/dokument`, _dokument, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                            break
                        case 'VIEWING':
                            //console.log("viewing - nothing") 
                            break
                        case 'DELETE':
                            console.log("delete - existing dokument")  
                            console.log(dokument)
                            if(dokument.dokumentId!==null)
                            {
                                console.log("dokumentId is not null "+dokument.dokumentId)
                                axios.delete(URLEndPointBE+`/delete/dokument/`+dokument.dokumentId, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                            }
                            break  
                        default:
                            //console.log("default - N/A")   
                            break
                    }
                });
            })
            .catch(function(error) {
                console.log(error);
                _succ=false;
            })
            console.log("redirecting")
            if(_succ) {
                console.log("navigating, _succ: true")
                setTimeout(function() {
                    navigate('/doplnky/doplnek/'+formId, {state: {succ: true, type: 'EDITACE', item: 'DOPLNKU'}});
                }, 1500);
            }  
    }
    
    useEffect(() => {
        dispatch(setMenuSelected("doplnky"));
        console.log("useEffect()")

        //Rodiny pro edit form - TODO pick from Redux later (don't refetch)
        axios.get(URLEndPointBE+`/dict-misc/rodiny-povrchu`) //here `doplnky` use same as `povrchy`
            .then((response) => {
                let _rodinyPouziti = response.data.reduce((listVals: any, r: any) => ([...listVals, {rodina_kod: r.kod, pouziti_id: 99, podminka: ""}]), [])
                let _rodinyPouziti2 = _rodinyPouziti.slice()
                //When existing EDIT=true
                if(props.edit) {
                    for(let cond of props.doplnek.doplnkyPouziti) { // !! pri editaci ADD podminka v cond.
                        //cond {rodina_kod, pouziti_id} for form
                        _rodinyPouziti2 = _rodinyPouziti2.map((x: any) => (x.rodina_kod==cond.rodina_kod?{...x, pouziti_id: cond.pouziti_id}: x))    
                    }
                }
                setFormDoplnkyPouziti(_rodinyPouziti2)
            })
            .catch((error) => {
                console.log("Err rodiny povrchu", error)
            })
        //Set doplnek from props if edit=true
        if(props.edit) {
            console.log("props.doplnky dump")
            console.log(props.doplnek)
            //not leaded yet mby
            setFormId(props.doplnek.id)
            setFormKod(DeEscapeTxt(props.doplnek.kod))
            setFormNazev(DeEscapeTxt(props.doplnek.nazev))
            let fotky = props.doplnek.foto?.reduce((listFotky: any, fotka: any) => ([...listFotky, {id: fotka.fotoId, state:"VIEWING", type: "", base64: ""}]), [])
            let fotky2 = [];
            //HOTFIX when foto:null
            if(props.doplnek.foto!==null){
                for(let i = 0; i < 2; ++i) {
                    if(fotky[i]!==undefined) {
                     fotky2[i] = fotky[i]
                 } else {
                        fotky2[i] = {id: "", state: "WAITING", type: "", base64: ""};
                    }
                }
            } else {
                fotky2[0] = {id: "", state: "WAITING", type: "", base64: ""};  
                fotky2[1] = {id: "", state: "WAITING", type: "", base64: ""};  
            }
            setFormFotky(fotky2)
            console.log("fotky2")
            console.log(fotky2)
            setFormViditelnost(props.doplnek.viditelnost)
            //setFormDoplnkyPouziti(...)  ^^ ABOVE
            setFormKlasifikace(props.doplnek.klasifikace)
            setFormPopis(DeEscapeTxt(props.doplnek.popis))
            setFormModifikace(DeEscapeTxt(props.doplnek.modifikace))
            setFormPoznamka(DeEscapeTxt(props.doplnek.poznamka))
            setFormDostupnost(DeEscapeTxt(props.doplnek.dostupnost))
            let dokumenty = props.doplnek.dokumenty?.reduce((listDokumenty: any, dok: any) => ([...listDokumenty, {dokumentId: dok.dokumentId, state:"VIEWING", base64: ""}]), [])
            //HOTFIX when foto:null
            if(props.doplnek.dokumenty!==null) {
                console.log("dokumenty")
                console.log(dokumenty);
                setFormDokumenty(dokumenty);
            } else {
                setFormDokumenty([]);
            }
        }
    }, [])
    return (<Container>
        <div>
            <Table hover>
                <thead>
                    <tr>
                        <th className='justWrap'><span className="katBtnStyle ptHover" onClick={() => {navigate(-1)}} > &lt; ZPĚT </span></th>
                        <th>DOPLNĚK</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='justWrap'>KOD</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formKod) ? formKod: ""}
                                onChange={(e: any) => {setFormKod(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th className='justWrap'>NÁZEV</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formNazev) ? formNazev : ""}
                                onChange={(e: any) => {setFormNazev(e.target.value)}}
                            />
                        </td>
                    </tr>
                    {/*<tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td>
                            <div className={'wrapperFoto'}>
                                <div className={'divFoto'}>
                                    <div className={'fotoFrame'}>
                                    {(foto!==null)
                                     ? <img src={(formFotografie1!=="") ? formFotografie1 : URLEndPointBE+`/foto/`+foto[0]?.fotoId }/>
                                     : <img src={(formFotografie1!=="") ? formFotografie1 : URLEndPointBE+`/foto/#` } /> }
                                    </div>
                                    <span>&nbsp;</span>
                                    <ReactFileReader fileTypes={[".jpg", ".png", ".jpeg"]} base64={true} multipleFiles={false} handleFiles={(e: any) => handleFile(1, e)}>
                                        <span className='katBtnStyle ptHover'>PŘIDAT FOTO</span>
                                    </ReactFileReader>
                                </div>
                                <div className={'divFoto'}>
                                    <div className={'fotoFrame'}>
                                    {(foto!==null)
                                     ? <img src={(formFotografie2!=="") ? formFotografie2 : URLEndPointBE+`/foto/`+foto[1]?.fotoId }/>
                                     : <img src={(formFotografie2!=="") ? formFotografie2 : URLEndPointBE+`/foto/#` }/> }
                                    </div>
                                    <span>&nbsp;</span>
                                    <ReactFileReader fileTypes={[".jpg", ".png", ".jpeg"]} base64={true} multipleFiles={false} handleFiles={(e: any) => handleFile(2, e)}>
                                        <span className='katBtnStyle ptHover'>PŘIDAT FOTO</span>
                                    </ReactFileReader>
                                </div>
                            </div>
                            </td>
                    </tr>*/}
                    <tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td>
                            <div className={'wrapperFoto'}>
                                {formFotky.map( (foto: any, i) => <span>
                                    <HandleFoto i={i} foto={foto} handle_pridat_foto={handlePridatFoto} handle_smazat_foto={handleSmazatFoto}/>
                                </span> )}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VIDITELNOST</th>
                        <td>
                            <label>
                                <select onChange={(e: any) => {setFormViditelnost(e.target.value)}} value={formViditelnost}>
                                    {viditelnost.map((vid: any) =>
                                    <option key={vid.key} value={vid.key}>{vid.value}</option>)}
                                </select>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POUŽITÍ</th>
                        <td className={"tableWrapCenter"}>
                            <table>
                                <tbody>
                                    {formDoplnkyPouziti.map((rod: any) =>
                                    <tr key={rod.rodina_kod}>
                                        <td style={{textAlign: 'right'}}><span>{rod.rodina_kod}&nbsp;</span></td>
                                        <td><RodinaSelection pouziti={pouziti} sel_rod={rod.rodina_kod} sel_pouz={rod.pouziti_id} propagate_up_ref={handleFormDoplnkyPouzitiChanged}/></td>
                                        <td>
                                            {/*<Input
                                                className={'filterInputStyle'}
                                                value={rod.podminka}
                                                onChange={(e: any) => {handleFormDoplnkyPouzitiTxtChanged(rod.rodina_kod, e.target.value)}}
                                            />*/}
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>KLASIFIKACE</th>
                        <td>
                            <select onChange={(e: any) => {setFormKlasifikace(e.target.value)}} value={formKlasifikace}>
                                {klasifikace.map((klasif: any) =>
                                <option key={klasif.key} value={klasif.key}>{klasif.value}</option>)}
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POPIS</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPopis) ? formPopis : ""}
                                onChange={(e: any) => {setFormPopis(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MODIFIKACE</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formModifikace) ? formModifikace : ""}
                                onChange={(e: any) => {setFormModifikace(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POZNÁMKA</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPoznamka) ? formPoznamka : ""}
                                onChange={(e: any) => {setFormPoznamka(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOSTUPNOST</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formDostupnost) ? formDostupnost : ""}
                                onChange={(e: any) => {setFormDostupnost(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOKUMENTY</th>
                        <td>
                            <div style={{textAlign: "center"}}>
                            {console.log("formDokumenty")}
                            {console.log(formDokumenty)}
                            {formDokumenty?.map((dokument: IDokument, index:number) =>
                            <span>
                                <HandleDokument dokumentId={dokument.dokumentId} state={dokument.state} base64d={dokument.base64d} arr_idx={index} handle_smazat_dokument={handleSmazatDokument}/>
                            </span>)}
                            {/* (typeof (formDokumenty) !== 'undefined' && formDokumenty!==null)
                            ? <span>{formDokumenty.map((dokument: any) => {(dokument.action!="DEL")?<DisplayDokument action={dokument.action} dokumentId={dokument.dokumentId}/>:<span>&nbsp;</span>} )}</span>
                                : <span>&mdash;</span> */} 
                            {/*if dokument.action=="NA", na-display, del red, green new*/}
                            {/*{(typeof (doplnek_doplnekId?.dokumenty) !== 'undefined' && doplnek_doplnekId?.dokumenty!=null)
                            ? <span>{doplnek_doplnekId?.dokumenty.map((dokument: any) => <DisplayDokument dokumentId={dokument.dokumentId}/> )}</span>
                            : <span>&mdash;</span>}</td>   
                            */}
                            {/*<span className={"documentUploadStyle"}>
                                <b>D</b>&nbsp;<span className={"docName"}>20221019_doku_dopln.pdf</span>
                                &nbsp;<span className="katBtnStyle">&#x1F50E;&#xFE0E;</span>
                                &nbsp;<span className="katBtnStyle">&#9249;</span>
                            </span>
                            <span>&nbsp;</span>
                            <span className={"documentUploadStyle"}>
                                <b>D</b>&nbsp;<span className={"docName"}>doplnujici_info.pdf</span>
                                &nbsp;<span className="katBtnStyle">&#x1F50E;&#xFE0E;</span>
                                &nbsp;<span className="katBtnStyle">&#9249;</span>
                                </span>*/}
                            <span>&nbsp;</span>  
                            <span style={{display: "inline-block"}}>
                                <ReactFileReader fileTypes={[".pdf"]} base64={true} multipleFiles={false} handleFiles={(e: any) => handlePridatDokument(e) }>  
                                    <span className="katBtnStyle ptHover" onClick={() => {console.log("+")}}>+</span>
                                </ReactFileReader>
                            </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>   
            { (props.edit)
              ? <span className="katBtnStyle ptHover" onClick={() => {UpdateDoplnek()}} > AKTUALIZOVAT </span>
              : <span className="katBtnStyle ptHover" onClick={() => {AddDoplnek()}} > PŘIDAT </span>}
            <span>&nbsp;</span>
            <p>&nbsp;</p>
        </div>
    </Container>)
}
export default ModifFormDoplnek